export const isLazyRouteMapExperimentEnabled = (): boolean =>
	(typeof window !== 'undefined' && window.BUILD_EXPERIMENT === 'route-experiment') ?? false;
